// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1Agov","content":"Consent_content__3OEEU","footer":"Consent_footer__1zlIZ"};